import React from 'react';
import { tUi } from '../../../../../../../../utils/dq_lc';
import {
  SlideDescription,
  PointText,
} from '../../../../../styles/LearnTab/slideBase.styles';
import { SlideTitleHeader } from '../common/SlideTitleHeader.comp';
import { renderTextWithId } from '../common/EditableSlideField.comp';

export const WorkedExampleSlide = ({
  slide,
  highlightWord,
  slideEdits = {},
  showEnglishContent = false,
  uiLocale = 'en-US',
}) => {
  const w = slide?.WorkedExampleData;
  const accent = '#3D5AFE';

  const textRendererOptions = { slideEdits, showEnglishContent, highlightWord };

  if (!w) {
    return (
      <SlideDescription>
        <SlideTitleHeader
          slide={slide}
          slideEdits={slideEdits}
          showEnglishContent={showEnglishContent}
          highlightWord={highlightWord}
        />
        {renderTextWithId('content_0', slide?.SlideContent, PointText, {}, textRendererOptions)}
      </SlideDescription>
    );
  }

  return (
    <SlideDescription>
      <SlideTitleHeader
        slide={slide}
        slideEdits={slideEdits}
        showEnglishContent={showEnglishContent}
        highlightWord={highlightWord}
      />
      {w.example_brief && (
        <PointText style={{ marginBottom: 12 }}>
          {renderTextWithId('we_brief', w.example_brief, 'span', {}, textRendererOptions)}
        </PointText>
      )}
      <ol style={{ paddingLeft: 20 }}>
        {(w.steps || []).map((st, idx) => (
          <li key={idx} style={{ marginBottom: 12 }}>
            <PointText>
              <strong>{st.step_label}</strong>
              {st.step_label && st.action ? ' — ' : ''}
              {renderTextWithId(`we_act_${idx}`, st.action || '', 'span', {}, textRendererOptions)}
            </PointText>
            {st.outcome && (
              <PointText style={{ fontStyle: 'italic', marginTop: 2 }}>
                → {renderTextWithId(`we_out_${idx}`, st.outcome, 'span', {}, textRendererOptions)}
              </PointText>
            )}
            {st.rationale && (
              <PointText style={{ fontSize: '0.9em', opacity: 0.8, marginTop: 2 }}>
                {renderTextWithId(`we_rat_${idx}`, st.rationale, 'span', {}, textRendererOptions)}
              </PointText>
            )}
          </li>
        ))}
      </ol>
      {w.conclusion && (
        <div style={{ borderLeft: `4px solid ${accent}`, background: `${accent}10`, padding: '10px 14px', borderRadius: 8, marginTop: 8 }}>
          <PointText><strong>{tUi('slide.workedExample.takeaway', uiLocale)}</strong> {renderTextWithId('we_concl', w.conclusion, 'span', {}, textRendererOptions)}</PointText>
        </div>
      )}
    </SlideDescription>
  );
};

export default WorkedExampleSlide;
